import { getComponentNameByGatewayId } from '../util/components';

const selectors = {
	/**
	 * This is technically only needed temporarily to lazy-fetch longId and env
	 * in a resolver. Maybe there are better ways to deal with this?
	 */
	getExtensionData: ( state ) => state.extension,
	getLongId: ( state ) => state.longId,
	getEnv: ( state ) => state.env,
	getSdkVersion: ( state ) => state.sdkVersion,
	getSdkIntegrity: ( state ) => state.sdkIntegrity,
	getSdk: ( state ) => state.sdk,
	isHostedModeForced: ( state ) => state.forceHostedFlow,
	getActivePaymentMethod: ( state ) => state.activePaymentMethod,
	getOrderId: ( state ) => state.orderId,
	getLongIdToCharge: ( state ) => state.longIdToCharge,
	getOnPaymentUnsuccessfulNonce: ( state ) => state.onPaymentUnsuccessfulNonce,

	// Component handling.

	getAllComponents: ( state ) => state.components,
	getComponentByName: ( state, componentName ) => state.components[ componentName ] ?? {},
	getActiveComponent: ( state ) => {
		const componentName = getComponentNameByGatewayId( state.activePaymentMethod );
		return state.components[ componentName ] ?? {};
	},
};

export default selectors;
